import React from 'react';
import { Field, FieldArray, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import { WorkerFormValidator } from './WorkerFormValidator';
import Card from '../../../shared/components/Card';
import CardHeader from '../../../shared/components/card-header/CardHeader';
import CardBody from '../../../shared/components/CardBody';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import { FormText } from '../../../shared/components/FormText';
import Row from '../../../shared/components/Row';
import { FormSwitch } from '../../../shared/components/FormSwitch';
import { FormSubmit } from '../../../shared/components/FormSubmit';
import { ResourceContractorSchemas } from '../../../shared/components/predefined-fields/resource-contractor-schema/ResourceContractorSchemas';
import DocumentSchemaType from '../../../shared/model/DocumentSchemaType';

const FORM = {
    NAME: 'MyContractorsWorkerForm',
    FIELDS: {
        DNI: 'dni',
        STATE: 'state',
        NAME: 'name',
        LAST_NAME: 'lastName',
        AGREEMENT: 'agreement',
        CONTRACTOR_SCHEMAS: 'contractorSchemas',
    },
};

class WorkerFormContent extends React.Component {

    render() {
        const {
            title,
            onSubmit,
            handleSubmit,
            initialValues,
            workerId,
            handleSetRefreshQrToken,
            refreshQrToken,
            handleTokenLoading,
            loading,
            contractorManagerDisabledFields,
        } = this.props;

        if ( initialValues.contractorId === -1 ) return null;

        return (
            <Card loading={loading}>
                <CardHeader title={title.toUpperCase()}/>
                <CardBody>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Row>
                            <Field
                                col="col-md-6"
                                name={FORM.FIELDS.DNI}
                                label={I18nUtils.tr('TR_DNI_NIE')}
                                placeholder={I18nUtils.tr('TR_INTRODUCE_EL_DNI_NIE_DEL_TRABAJADOR')}
                                component={FormText}
                                disabled={contractorManagerDisabledFields}
                            />
                            <Field
                                col="col-md-6"
                                name={FORM.FIELDS.STATE}
                                label={I18nUtils.tr('TR_ESTADO')}
                                labelDisabled={I18nUtils.tr('TR_INACTIVO')}
                                labelEnabled={I18nUtils.tr('TR_ACTIVO')}
                                component={FormSwitch}
                            />
                        </Row>
                        <Row>
                            <Field
                                col="col-md-6"
                                name={FORM.FIELDS.NAME}
                                label={I18nUtils.tr('TR_NOMBRE')}
                                placeholder={I18nUtils.tr('TR_INTRODUCE_EL_NOMBRE_DEL_TRABAJADOR')}
                                component={FormText}
                                disabled={contractorManagerDisabledFields}
                            />
                            <Field
                                col="col-md-6"
                                name={FORM.FIELDS.LAST_NAME}
                                label={I18nUtils.tr('TR_APELLIDO_S')}
                                placeholder={I18nUtils.tr('TR_INTRODUCE_EL_LOS_APLLIDO_S_DEL_TRABAJADOR')}
                                component={FormText}
                                disabled={contractorManagerDisabledFields}
                            />
                        </Row>
                        <Row>
                            <Field
                                col="col-md-12"
                                name={FORM.FIELDS.AGREEMENT}
                                label={I18nUtils.tr('TR_CONVENIO_DE_APLICACION')}
                                placeholder={I18nUtils.tr('TR_INTRODUCE_EL_CONVENIO_DE_APLICACION')}
                                component={FormText}
                                disabled={contractorManagerDisabledFields}
                            />
                        </Row>
                        <Row>
                            <div className="col-sm-12 form-field-list">
                                <label>{I18nUtils.tr('TR_CONTRATISTA_ESQUEMA_DOCUMENTACION_OFICIO')}</label>
                                <FieldArray
                                    name={FORM.FIELDS.CONTRACTOR_SCHEMAS}
                                    component={ResourceContractorSchemas}
                                    initialValues={initialValues}
                                    documentSchemaType={DocumentSchemaType.WORKER}
                                    workerId={workerId}
                                    handleSetRefreshQrToken={handleSetRefreshQrToken}
                                    refreshQrToken={refreshQrToken}
                                    handleTokenLoading={handleTokenLoading}
                                    showPositionField={true}
                                    contractorManagerDisabledFields={contractorManagerDisabledFields}
                                />
                            </div>
                        </Row>
                        <Row>
                            <Field
                                label={I18nUtils.tr('TR_GUARDAR')}
                                name="submit"
                                col="col-md-6 col-md-offset-6"
                                component={FormSubmit}
                            />
                        </Row>
                    </form>
                </CardBody>
            </Card>
        );
    }
}

export const WorkerForm = reduxForm({
    form: FORM.NAME,
    validate: WorkerFormValidator.validate,
})(WorkerFormContent);

WorkerForm.propTypes = {
    title: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired,
    initialValues: PropTypes.object.isRequired,
    workerId: PropTypes.number,
    handleSetRefreshQrToken: PropTypes.func,
    refreshQrToken: PropTypes.bool,
    handleTokenLoading: PropTypes.func,
    loading: PropTypes.bool,
    contractorManagerDisabledFields: PropTypes.bool,
};

WorkerForm.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/my-contractors/worker/form/WorkerForm.jsx